import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { updateChoice } from "areas/product/store/actions"
import { Typography } from "components/common"
import { to_currency } from "helpers/number"
import { filterProductOptions } from "helpers/product/product-filtering"
import { useNavigation } from "helpers/use-navigation"

import {
  ChoiceOption,
  GradientContainer,
  OptionsSlider,
  OptionTitle,
  OptionPrice,
} from "./components"

const CageHeadDescriptionWrapper = styled(Typography)`
  border-bottom: dotted thin #cccccc;
  margin-bottom: 10px;
  min-height: 77px;
  padding-bottom: 10px;
  padding-left: 0;
  &.hide_attributes {
    min-height: 50px;
  }
`

const CageHeadDescriptionTitle = styled.h3`
  color: #313131;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.5px;
  margin: 0 0 3px;
`

const CageHeadDescriptionInfo = styled.p`
  color: #a0a0a0;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.5px;
  margin: 0;
`
const ChoiceOptions = ({
  setComponent,
  selectedValue,
  setChoice,
  data,
  filter,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label={`${data.heading.title} Options`}
      data-slider="true"
      role="radiogroup"
    >
      {filterProductOptions(data.options, filter, true).map(
        (component_option) => {
          const selected = selectedValue.value == component_option.value
          return (
            <ChoiceOption
              aria-selected={selected}
              data-cy={`product-wizard-option-${component_option.pref}-${component_option.value}`}
              data-is-option="true"
              data-is-selected={selected}
              data-pref={data.pref}
              data-price={component_option.price}
              data-sia={component_option.sia}
              data-summary-field="chead"
              data-title={component_option.title}
              data-value={component_option.value}
              key={`cageHeadOption-${component_option.value}`}
              onClick={(e) => {
                setChoice(data.pref, component_option, e)
              }}
              onMouseOut={() => setComponent(selectedValue)}
              onMouseOver={() => setComponent(component_option)}
              role="radio"
              selected={selected}
              tabIndex={selected ? 0 : -1}
              {...keyboardProps}
            >
              <img
                alt={component_option.title}
                className="lazyload"
                data-src={component_option.image}
                height="65"
                src={require("images/icons/jewlr.gif")}
                title={component_option.title}
                width="65"
              />
              <OptionTitle>{component_option.title}</OptionTitle>
              <OptionPrice>
                {component_option.price > 0
                  ? to_currency(component_option.price)
                  : ""}
              </OptionPrice>
            </ChoiceOption>
          )
        }
      )}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  data: PropTypes.object,
  filter: PropTypes.object,
  selectedValue: PropTypes.object,
  setChoice: PropTypes.func,
  setComponent: PropTypes.func,
}

const InternalCageHeadOptions = ({
  data,
  selectedValue,
  setChoice,
  filter,
}) => {
  if (!data) {
    return null
  }

  const [component, setComponent] = useState(selectedValue)
  return (
    <div>
      <CageHeadDescriptionWrapper
        as="div"
        display={{ _: "none", tablet: "block" }}
      >
        <CageHeadDescriptionTitle>
          {component.title} - {to_currency(component.price)}
        </CageHeadDescriptionTitle>
        <CageHeadDescriptionInfo>
          {component.description}
        </CageHeadDescriptionInfo>
      </CageHeadDescriptionWrapper>

      <GradientContainer data={data.heading}>
        <FocusScope>
          <ChoiceOptions
            data={data}
            filter={filter}
            selectedValue={selectedValue}
            setChoice={setChoice}
            setComponent={setComponent}
          />
        </FocusScope>
      </GradientContainer>
    </div>
  )
}

InternalCageHeadOptions.propTypes = {
  data: PropTypes.object,
  filter: PropTypes.object,
  selectedValue: PropTypes.object,
  setChoice: PropTypes.func,
}

const getFilter = (state, ownProps) => {
  const pref = "sku"
  const value =
    state.choices && state.choices.sku ? state.choices.sku.value || "" : ""
  return { pref, value }
}

const getSizeFilter = (state, ownProps) => {
  const size =
    state.choices && state.choices.sz ? state.choices.sz.value || "" : ""
  return size
  // return {
  //   pref: 'sz',
  //   value: size
  // }
}
const mapStateToProps = (state, ownProps) => {
  return {
    data: state.wizard.data[ownProps.pref],
    filter: getFilter(state, ownProps),
    selectedValue: state.choices[ownProps.pref],
    sizeFilter: getSizeFilter(state, ownProps),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (pref, data, e) => {
      dispatch(updateChoice(pref, data, true))
    },
  }
}

const CageHeadOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalCageHeadOptions)

export default CageHeadOptions
